module.exports = __webpack_public_path__ + "media/images/pages/fcr-case/case-8-7b11e173da1fe16460bc2e289d237059.png";